import { createContext, useContext } from 'react';
import * as React from 'react';
import { ID } from '@sdk/newsfeed/types/apiTypes';

import { ArticleSearchProviderState } from '@web/newsfeed/ArticleSearch/ArticleSearchProvider/articleSearchProvider.types';
import { Page } from '@web/newsfeed/ArticleSearch/types/Page';

type Props = {
  articleId?: ID;
  page: Page;
  searchPageId: ID;
  searchQuery: string;
  children: React.ReactNode;
};

export const ArticleSearchStateContext = createContext<ArticleSearchProviderState>({
  articleId: null,
  page: null,
  searchPageId: null,
  searchQuery: '',
} as ArticleSearchProviderState);
export const useArticleSearchContext = (): ArticleSearchProviderState =>
  useContext(ArticleSearchStateContext);

export const ArticleSearchProvider = ({
  articleId,
  page,
  searchPageId,
  searchQuery,
  children,
}: Props) => {
  const value = {
    articleId,
    page,
    searchPageId,
    searchQuery,
  };

  return (
    <ArticleSearchStateContext.Provider value={value}>
      {children}
    </ArticleSearchStateContext.Provider>
  );
};
